/* eslint-disable camelcase */
export enum ProductTypes {
  Glasses = 'Glasses',
  Upsell = 'Upsell',
}

export enum OrderStep {
  Glasses = 0,
  Prescription = 1,
  Options = 2,
}

export enum PrescriptionChoice {
  Later = 'Sender brilleseddel senere',
  Account = 'Bruk brilleseddel fra kundekonto',
  Form = 'Brilleseddel vedlagt',
}

export interface ShopifyCartUpdateData {
  note?: string;
  attributes?: {
    [key: string]: string;
  };
}

export interface Product {
  id: number | null;
  title: string;
  price: number | null;
  description: string;
  type: string;
  handle?: string;
  properties?: {
    [key: string]: string;
  };
  variants: ShopifyVariant[];
}
export interface OrderItem {
  quantity: number;
  id: number;
  properties?: {
    [key: string]: string | number | number[];
  };
}

export interface Prescription {
  title: string;
  data: string | prescriptionData;
}

export interface prescriptionData {
  left_sphere: string;
  left_cylinder: string;
  left_axis: string;
  right_sphere: string;
  right_cylinder: string;
  right_axis: string;
  p_d: string;
}

export interface OrderData {
  glasses: Product | null;
  glassExtra: Product | null;
  upsells: Product[];
}

export interface ShopifyOrderData {
  items: OrderItem[];
}

export interface ShopifyProduct {
  available: boolean;
  compare_at_price: null;
  compare_at_price_max: number;
  compare_at_price_min: number;
  compare_at_price_varies: boolean;
  created_at: string;
  description: string;
  featured_image: string;
  handle: string;
  id: number;
  images: string[];
  options: [{ name: string; position: number; values?: string[] }];
  price: number;
  price_max: number;
  price_min: number;
  price_varies: boolean;
  properties?: {
    [key: string]: string;
  };
  published_at: string;
  tags: string[];
  title: string;
  type: string;
  url: string;
  variants: ShopifyVariant[];
  vendor: string;
}

export interface ShopifyVariant {
  available: boolean;
  barcode: string;
  compare_at_price: null;
  featured_image: string | null;
  id: number;
  inventory_management: string | null;
  name: string;
  option1: string;
  option2: string | null;
  option3: string | null;
  options: string[];
  price: number;
  public_title: string | null;
  requires_shipping: boolean;
  sku: string | null;
  taxable: boolean;
  title: string;
  weight: number;
}

export interface ShopifyPredictiveSearch {
  resources: {
    results: {
      products: ShopifyProduct[];
    };
  };
}
